var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":"brand_link","href":"https://www.germanchatterbox.com","title":_vm.version_info}},[_c('img',{attrs:{"src":"/img/chatterboxbanner7.png","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }